import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;

  picture {
    display: block;
    width: 100%;
  }

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
  }
`;

export const OverlayWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
`;
